/**
 * @generated SignedSource<<0f4be93d6a986ceb544a7c05977a7572>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type StudentsSkillSubStateReportInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillIds: ReadonlyArray<string>;
  skillResult: SkillResult;
};
export type MonitoringSkillSubStateReporQuery$variables = {
  filter: StudentsSkillSubStateReportInput;
  skip?: boolean | null | undefined;
};
export type MonitoringSkillSubStateReporQuery$data = {
  readonly studentsSkillSubStateReport?: ReadonlyArray<{
    readonly skill: {
      readonly id: string;
    };
    readonly usersBySkillResults: ReadonlyArray<{
      readonly key: SkillResult;
      readonly value: ReadonlyArray<{
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
      }>;
    }>;
  }>;
};
export type MonitoringSkillSubStateReporQuery = {
  response: MonitoringSkillSubStateReporQuery$data;
  variables: MonitoringSkillSubStateReporQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "SkillProgress",
        "kind": "LinkedField",
        "name": "studentsSkillSubStateReport",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfSkillResultAndIEnumerableOfUser",
            "kind": "LinkedField",
            "name": "usersBySkillResults",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUserId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MonitoringSkillSubStateReporQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MonitoringSkillSubStateReporQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b6a26e26812122d1eac7dfe05106d53b",
    "id": null,
    "metadata": {},
    "name": "MonitoringSkillSubStateReporQuery",
    "operationKind": "query",
    "text": "query MonitoringSkillSubStateReporQuery(\n  $filter: StudentsSkillSubStateReportInput!\n  $skip: Boolean = false\n) {\n  studentsSkillSubStateReport(filter: $filter) @skip(if: $skip) {\n    skill {\n      id\n    }\n    usersBySkillResults {\n      value {\n        id\n        firstName\n        lastName\n        publicUserId\n      }\n      key\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "508ab2eba3e9c55d375839db5b91317d";

export default node;
